import { Snackbar, Alert, type AlertProps } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../redux/store";
import { removeSnackbar } from "../../redux/snackbarSlice";

const severityToAlertVariant: Record<string, AlertProps["variant"] & {}> = {
  success: "filled",
  error: "filled",
  warning: "filled",
  info: "filled",
};

const SnackbarContainer = () => {
  const messages = useAppSelector((state) => state.snackbar.messages);
  const dispatch = useAppDispatch();

  if (messages.length === 0) return null;

  const current = messages[0];

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    dispatch(removeSnackbar(current.id));
  };

  return (
    <Snackbar
      key={current.id}
      open
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={current.severity}
        variant={severityToAlertVariant[current.severity] ?? "filled"}
        sx={{ width: "100%", direction: "rtl" }}
      >
        {current.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarContainer;
